import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { LegalPage, LegalSection } from '@/components/legal/legal-page'

const CookiesPolicy: FC = (): ReactNode => {
    return (
        <LegalPage
            title='Política de cookies'
            description='Qué cookies utiliza el sitio web de Jeme y cómo puedes gestionarlas.'
            intro={(
                <p>
                    En esta página te explicamos qué son las cookies y cómo las utiliza este sitio web.
                </p>
            )}
        >
            <LegalSection title='1. Qué son las cookies'>
                <p>
                    Las cookies son pequeños archivos que algunos sitios web guardan en tu navegador para recordar información sobre tu visita.
                </p>
            </LegalSection>

            <LegalSection title='2. Cookies que utiliza este sitio'>
                <p>
                    Este sitio web no utiliza cookies con fines analíticos, publicitarios o de seguimiento. Las estadísticas de visitas se obtienen con un sistema que no instala cookies ni te identifica, como explicamos en la <Link href='/privacidad'>política de privacidad</Link>.
                </p>

                <p>
                    Podría utilizar cookies técnicas estrictamente necesarias para su funcionamiento y su seguridad, que no requieren tu consentimiento.
                </p>
            </LegalSection>

            <LegalSection title='3. Sitios de terceros'>
                <p>
                    Si sales de este sitio a través de un enlace, por ejemplo a las tiendas de aplicaciones, ese sitio puede usar sus propias cookies, que se rigen por su política.
                </p>
            </LegalSection>

            <LegalSection title='4. Cómo gestionarlas'>
                <p>
                    Puedes permitir, bloquear o eliminar las cookies desde la configuración de tu navegador.
                </p>
            </LegalSection>

            <LegalSection title='5. Cambios en esta política'>
                <p>
                    Si en el futuro incorporamos otras cookies, actualizaremos esta política y, cuando sea necesario, te pediremos tu consentimiento.
                </p>
            </LegalSection>
        </LegalPage>
    )
}

export default CookiesPolicy
